import React, { useEffect } from 'react';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import {
    FaPhoneAlt,
    FaMapMarkerAlt,
    FaGlobe,
    FaShippingFast,
    FaCheckCircle,
    FaLeaf,
    FaHandHoldingHeart,
    FaAward,
} from 'react-icons/fa';

export default function About() {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <div className="text-gray-800 bg-white">
            {/* Hero Section */}
            <section className="bg-yellow-100 py-16 px-4 text-center">
                <h1 className="text-4xl font-extrabold text-yellow-700 mb-4" data-aos="fade-down">
                    About AXS Enterprises
                </h1>
                <p className="text-lg text-gray-700 max-w-2xl mx-auto" data-aos="fade-up">
                    Delivering the finest dry fruits, spices, and grains from India to the world — ethically sourced, quality assured.
                </p>
            </section>

            {/* About Section */}
            <section className="max-w-6xl mx-auto px-4 py-16">
                <div className="grid md:grid-cols-2 gap-10 items-center">
                    {/* Text Section */}
                    <div data-aos="fade-right">
                        <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                            <strong>AXS Enterprises</strong>, founded in <strong>2024</strong>, is a premier manufacturer, trader,
                            and global exporter of top-quality dry fruits, spices, garam masala, rice, and other agricultural
                            products. <br /> <br /> Our vision is to deliver authenticity, purity, and health in every bite. From
                            India's heartland to the world's table — we uphold the highest standards of freshness and flavor.
                        </p>

                        <div className="space-y-4 text-sm text-gray-600">
                            <div className="flex items-center gap-3">
                                <FaPhoneAlt className="text-yellow-500" /> <span>+91 99904 04922</span>
                            </div>
                            <div className="flex items-center gap-3">
                                <FaMapMarkerAlt className="text-yellow-500" /> <span>Uttam Nagar, New Delhi, India</span>
                            </div>
                            <div className="flex items-center gap-3">
                                <FaGlobe className="text-yellow-500" /> <span>Supplying Worldwide</span>
                            </div>
                        </div>
                    </div>

                    {/* Image Section */}
                    <div className="rounded-xl overflow-hidden shadow-2xl border border-yellow-100" data-aos="fade-left">
                        <img
                            src="https://images.unsplash.com/photo-1601004890684-d8cbf643f5f2?auto=format&fit=crop&w=800&q=80"
                            alt="Dry Fruits & Spices"
                            className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                        />
                    </div>
                </div>
            </section>

            {/* Highlights Section */}
            <section className="bg-yellow-50 py-16" data-aos="fade-up">
                <div className="max-w-6xl mx-auto px-4 text-center">
                    <h2 className="text-3xl font-bold text-yellow-700 mb-10">Why Choose AXS Enterprises?</h2>

                    <div className="grid md:grid-cols-3 sm:grid-cols-2 gap-10 text-left">
                        <div className="flex items-start gap-4" data-aos="fade-up">
                            <FaShippingFast className="text-yellow-600 text-3xl" />
                            <div>
                                <h4 className="font-semibold text-lg">Global Shipping</h4>
                                <p className="text-sm text-gray-600">
                                    Fast, reliable export operations across continents with end-to-end logistics support.
                                </p>
                            </div>
                        </div>

                        <div className="flex items-start gap-4" data-aos="fade-up" data-aos-delay="100">
                            <FaCheckCircle className="text-yellow-600 text-3xl" />
                            <div>
                                <h4 className="font-semibold text-lg">Premium Quality</h4>
                                <p className="text-sm text-gray-600">
                                    Stringent quality checks ensure only the finest products reach your kitchen.
                                </p>
                            </div>
                        </div>

                        <div className="flex items-start gap-4" data-aos="fade-up" data-aos-delay="200">
                            <FaLeaf className="text-yellow-600 text-3xl" />
                            <div>
                                <h4 className="font-semibold text-lg">Naturally Sourced</h4>
                                <p className="text-sm text-gray-600">
                                    Ethically procured ingredients from certified organic farms and local growers.
                                </p>
                            </div>
                        </div>

                        <div className="flex items-start gap-4" data-aos="fade-up" data-aos-delay="300">
                            <FaHandHoldingHeart className="text-yellow-600 text-3xl" />
                            <div>
                                <h4 className="font-semibold text-lg">Customer Commitment</h4>
                                <p className="text-sm text-gray-600">
                                    Dedicated service team ensuring a smooth and satisfying buying experience.
                                </p>
                            </div>
                        </div>

                        <div className="flex items-start gap-4" data-aos="fade-up" data-aos-delay="400">
                            <FaAward className="text-yellow-600 text-3xl" />
                            <div>
                                <h4 className="font-semibold text-lg">Industry Recognition</h4>
                                <p className="text-sm text-gray-600">
                                    Trusted by global clients for integrity, transparency, and consistent excellence.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <Footer />
        </div>
    );
}
